/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { IceNavService } from '../../components/ice-nav/ice-nav.service';

@Component({
  selector: 'app-loginflow',
  templateUrl: './loginflow.component.html',
  styleUrls: ['./loginflow.component.scss'],
  providers: [LoginService, IceNavService]
})
export class LoginflowComponent implements OnInit {
  signInUrl: string = "";
  registerUrl: string = "";
  constructor(loginsvc: LoginService, private navSvc: IceNavService) {
    this.signInUrl = loginsvc.GetLoginUrl('code');
    this.registerUrl = loginsvc.identity_registrationUri;
    navSvc.refresh();
  }

  ngOnInit() {
    this.navSvc.hideSideMenu(true);
    this.navSvc.showTopMenuParent(this.navSvc.topMenuMessagesParentElementID, false);
  }
}
